// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/search/services.scss
 ** module id = 429
 ** module chunks = 1
 **/